export const WISHLIST_DETAIL_RESERVATION_EMAIL_PATTERN = new RegExp('^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$');
